import { Component, Input, OnInit, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';
import { NzFormatEmitEvent, NzTreeComponent, NzTreeNodeOptions } from 'ng-zorro-antd/tree';
import { CommonService } from '../../service/common/common.service';

@Component({
  selector: 'employee-select',
  templateUrl: './employee-select.component.html',
  styleUrls: ['./employee-select.component.less'],
})
export class EmployeeSelectComponent implements OnInit {
  @Input() topTitle: string = '选择人员'; //  最顶部标题文案
  /**
   * 数据源
   */
  @Input() data: Array<object> = [];
  /**
   * 是否显示 boolean
   */
  @Input() show: boolean = false;
  /**
   * 是否显示推荐按钮  默认显示
   */
  @Input() hasRecommend: boolean = true;
  /**
   * 推荐人tab文本
   */
  @Input() recommendTitle: string = '推荐';
  /**
   * 显示模式 string  employee  员工 admin  管理岗员工 depart  部门 duties 岗位
   */
  @Input() model: string = 'employee';
  /**
   * 是否显示全部人员
   */
  @Input() showAll: boolean = true;
  /**
   * 选择模式 true 单选  false  多选
   */
  @Input() nzMultiple: boolean = false;
  /**
   * 组织架构
   */
  @Input() structure: Array<object> = [];
  /**
   * 已选择的数据
   * 结构: {key: 1,mobile: "13522279999",title: "苏总",value: 1}
   * key ,title , value 必填
   */
  @Input() checkData: Array<object> = [];
  /**
   * 推荐标题
   */
  @Input() checkTitle: string = '推荐面试官';
  /**
   * 确认按钮文字
   */
  @Input() sureText: string = '确认';
  /**
   * 取消按钮文字
   */
  @Input() cancelText: string = '取消';

  /**
   * 确定事件
   */
  @Output() sure = new EventEmitter();
  /**
   * 取消事件
   */
  @Output() cancel = new EventEmitter();
  isAll: boolean = false; // 判断tab的类型 true  全部 false 推荐
  allStructure: Array<object> = [];
  recommendData: Array<object> = []; // 处理后的推荐数据
  showRecommendData: Array<object> = []; // 用于展示的推荐数据
  showSearchData: Array<object> = []; // 检索后的用户数据
  sourceRecommendData: Array<object> = []; // 推荐源数据
  selectIds: Array<number> = []; // 选择的推荐用户的id
  allRecommend: boolean = false; // 是否全选推荐用户
  selectRecommendData: Array<object> = []; // 选中的推荐数据
  selectAllData: Array<object> = []; // 选中的全部数据
  selectResult: Array<object> = []; // 选中数据
  leftSearch: string = ''; // 左侧检索关键字
  leftSearchResult: Array<object> = [];
  rightSearch: string = ''; // 右侧检索关键字
  searchEmployeeData: Array<object> = []; // 检索的全部员工信息
  recommendCheckAll: boolean = false; // 推荐数据全选
  searchCheckAll: boolean = false; // 全部数据的全选
  leftSearchRecommend: string = ''; // 推荐数据检索关键字
  leftSearchAll: string = ''; // 全部数据检索关键字
  showAllNoData: boolean = false;

  constructor(private common: CommonService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['hasRecommend'] && !this.hasRecommend) {
      this.isAll = true;
    }
    /**
     * 判断改变先了显示隐藏状态且当前状态是显示
     */
    if (changes['show'] != undefined) {
      if (this.show) {
        this.dealResultShow(); // 将选中数据做回显
        if (this.checkData.length > 0) {
        }
        if (this.data != undefined && this.data.length != 0) {
          this.dealRecommend(this.data); // 处理推荐数据
        }
        this.allStructure = this.dealStructure(this.structure);
      } else {
        // 当组件关闭时，初始化组件数据信息
        this.init();
      }
    }
  }

  /**
   * 手动初始化方法 在组件特殊变量在改变值的时候就要进行手动初始化
   */
  init(): void {
    /**
     * 判断当前模式是否存在推荐数据
     */
    if (this.hasRecommend) {
      this.isAll = false;
    } else {
      this.isAll = true;
    }
    this.leftSearchAll = '';
    this.leftSearchRecommend = '';
    this.showAllNoData = false;
  }

  /**
   * 处理组织架构
   */
  dealStructure(data: Array<object>): any {
    const response: Array<object> = [];
    for (const structure of data) {
      const item = {};
      item['title'] = structure['organ_name'];
      item['key'] = 'organ_' + structure['organ_id'];
      item['realKey'] = structure['organ_id'];
      item['value'] = structure['organ_id'];
      item['parent'] = structure['organ_pid'];
      item['status'] = structure['status'];
      item['selectable'] = false;
      item['disableCheckbox'] = true;
      item['isEmployee'] = false;
      Object.assign(item, structure);
      delete item['child_node'];
      // 如果存在子数据则进行递归处理
      if (structure['child_node'].length > 0) {
        item['children'] = this.dealStructure(structure['child_node']);
      } else {
        if (structure['organ_peoples'] != 0) {
        } else {
          item['isLeaf'] = true;
        }
      }
      response.push(item);
    }
    return response;
  }

  /**
   * 处理推荐数据
   * @param data
   * @private
   */
  private dealRecommend(data: Array<object>): any {
    const response: Array<object> = [];
    for (const employee of data) {
      const item = {};
      item['title'] = employee['inverviewer_name'] ? employee['inverviewer_name'] : employee['username'];
      item['key'] = employee['inverviewer_uid'] ? employee['inverviewer_uid'] : employee['employee_id'];
      item['value'] = employee['inverviewer_uid'] ? employee['inverviewer_uid'] : employee['employee_id'];
      item['isLeaf'] = true;
      // item['organ_all_path'] = employee['organ_all_path'];
      Object.assign(item, employee);
      response.push(item);
    }
    this.recommendData = [...response];
    this.sourceRecommendData = [...response];
    this.showRecommendData = [...response];
  }

  /**
   * 选择推荐人员
   * @params key;
   * @param index
   */
  selectRecommend(key: number, index: number, event: any): void {
    if (typeof event != 'boolean') {
      event.stopPropagation();
    }
    const resultIndex = this.selectIds.indexOf(key);
    let selectIds = this.selectIds;
    let selectResult = [...this.selectResult];
    let selectItem: object = {};
    this.recommendData.map((item) => {
      if (item['key'] == key) {
        selectItem = item;
      }
    });
    // 判断当前选择模式是否是单选
    if (!this.nzMultiple) {
      // 判断当前数据是否是已经选中状态
      if (resultIndex > -1) {
        selectIds.splice(resultIndex, 1);
        selectResult.map((item, index) => {
          if (item['key'] == selectItem['key']) {
            selectResult.splice(index, 1);
          }
        });
      } else {
        selectResult.push(selectItem);
        selectIds.push(key);
      }
    } else {
      // 判断当前数据是否是已经选中状态
      if (resultIndex > -1) {
        selectIds = [];
        selectResult = [];
      } else {
        selectIds = [];
        selectResult = [];
        selectResult.push(selectItem);
        selectIds.push(key);
      }
    }

    this.selectResult = [...selectResult];
    this.selectIds = [...selectIds];
    // 判断选择模式是否是单选
    if (!this.nzMultiple) {
      this.allRecommend = this.selectIds.length == this.recommendData.length;
    }
    this.decisionCheckAll();
  }

  /**
   * 点击全选推荐用户
   * @param $event
   */
  allRecommendCheck($event: any): void {
    const _selectIds = [...this.selectIds];
    const _selectResult = [...this.selectResult];
    if ($event == false) {
      // 清除所有的推荐数据
      this.showRecommendData.map((item) => {
        const index = _selectIds.indexOf(item['key']);
        if (index > -1) {
          _selectIds.splice(index, 1);
          _selectResult.splice(index, 1);
        }
      });
      this.selectIds = [..._selectIds];
      this.selectResult = [..._selectResult];
    } else {
      // tslint:disable-next-line:prefer-for-of
      this.showRecommendData.map((item) => {
        if (_selectIds.indexOf(item['key']) == -1) {
          _selectResult.push(item);
          _selectIds.push(item['key']);
        }
      });
      this.selectResult = [..._selectResult];
      this.selectIds = [..._selectIds];
    }
    this.decisionCheckAll();
  }

  /**
   * 移除选择到的选项
   * @param item
   * @param index
   */
  delete(item: object, index: number): void {
    const _selectResult = [...this.selectResult];
    const _selectIds = [...this.selectIds];
    _selectResult.splice(index, 1);
    const selectIndex = _selectIds.indexOf(item['key']);
    _selectIds.splice(selectIndex, 1);
    this.selectResult = [..._selectResult];
    this.selectIds = [..._selectIds];
    this.allRecommend = this.selectIds.length == this.recommendData.length;
    this.decisionCheckAll();
  }

  /**
   * 点击部门获取员工
   * @param event
   */
  getEmployee(event: NzFormatEmitEvent): void {
    if (event.node.origin['organ_peoples'] == 0) {
      return;
    }
    if (event.node.origin.isEmployee) {
      const key = event.node.origin.key;
      let selectResult = [...this.selectResult];
      let selectIds = [...this.selectIds];
      if (!this.nzMultiple) {
        /**
         * 如果是点击已存在的数据
         */
        if (selectIds.indexOf(Number(key)) > -1) {
          this.selectResult.map((item, index) => {
            if (item['key'] == key) {
              selectResult.splice(index, 1);
            }
          });
          selectIds.splice(selectIds.indexOf(Number(key)), 1);
        } else {
          selectIds.push(Number(key));
          selectResult.push(event.node.origin);
        }
      } else {
        /**
         * 如果是点击已存在的数据
         */

        if (selectIds.indexOf(Number(key)) > -1) {
          selectIds = [];
          selectResult = [];
        } else {
          selectIds = [];
          selectResult = [];
          selectIds.push(Number(key));
          selectResult.push(event.node.origin);
        }
      }

      this.selectIds = [...selectIds];
      this.selectResult = [...selectResult];
    } else {
      // 判断点击的是部门且当前部门没有获取过管理岗
      if (!event.node.origin.hasEmployee || event.node.origin.hasEmployee == undefined) {
        const nodeIndex = this.getNodeIndex(event.node);
        let result = [];
        if (nodeIndex == undefined) {
          result.push(0);
        } else {
          result = this.getNodeIndex(event.node)
            .split(',')
            .filter((s) => {
              return s && s.trim();
            })
            .reverse();
        }
        this.getEmployeeApi(Number(event.node.origin.realKey)).then((res) => {
          if (res.length > 0) {
            this.showSearchData = [...res]; // 赋值检索后的数据
          }
          let structure = [...this.allStructure];
          structure = this.fillData(result, res, structure);
          this.allStructure = [...structure];
        });
      }
    }
  }

  async getEmployeeApi(id: number): Promise<any> {
    let search_type = 1;
    if (this.model == 'admin') {
      search_type = 2;
    }
    return new Promise((resolve) => {
      const ajaxUrl = search_type == 1 ? 'employee/getEmployeeByDepartForTool' : 'employee/getDepartAdminJob';
      this.common.ajax({
        url: ajaxUrl,
        data: { organ_id: id },
        loading: true,
        success: (res) => {
          resolve(res);
        },
      });
    });
  }

  /**
   * 获取数组所在位置
   * @param event
   */
  getNodeIndex(event: any): any {
    let targetIndex = 0;
    const parentNode = event.parentNode;
    let result = '';
    if (parentNode == null) {
      return;
    } else {
      // 遍历父级元素的子元素数据组  获取所在index
      parentNode.origin.children.map((item, index) => {
        if (item.key == event.origin.key) {
          targetIndex = index;
        }
      });
      result = ',' + targetIndex;
      if (parentNode.parentNode != null) {
        result = result + this.getNodeIndex(parentNode);
      } else {
        const key = parentNode.origin.key;
        this.allStructure.map((item, index) => {
          if (item['key'] == key) {
            result = result + ',' + index;
          }
        });
      }
      return result;
    }
  }

  /**
   * 将数据填充入组织架构
   * @param index
   * @param data
   */
  fillData(index: Array<any>, data: Array<object>, structure: Array<any>): any {
    if (index.length > 1) {
      const nowIndex = index.shift(); // 获取第一个元素并且将其从原数组中移除
      structure[nowIndex]['children'] = this.fillData(index, data, structure[nowIndex]['children']);
    } else {
      const nowIndex = index.shift(); // 获取第一个元素并且将其从原数组中移除
      structure[nowIndex]['isLeaf'] = false;
      structure[nowIndex]['hasEmployee'] = true;
      structure[nowIndex]['children'] = structure[nowIndex]['children'] ? structure[nowIndex]['children'] : [];
      //  遍历数据将数据压入源数据中
      data.map((item) => {
        structure[nowIndex]['children'].unshift({
          key: item['employee_id'],
          title: item['username'],
          mobile: item['mobile'],
          isLeaf: true,
          isEmployee: true,
          inverviewer_name: item['username'],
          inverviewer_uid: item['employee_id'],
          value: item['employee_id'],
        });
      });
    }
    return structure;
  }

  /**
   * 检索全部用户
   * @param $event
   */
  searchEmployee($event: any): void {
    this.leftSearchAll = $event.target.value;
    if (this.leftSearchAll == '') {
      this.leftSearchResult = [...[]];
      this.searchEmployeeData = [...[]];
      return;
    }

    if (!this.isAll) {
      return;
    }
    let search_type = 1;
    if (this.model == 'admin') {
      search_type = 2;
    }
    this.common
      .ajax({
        url: 'employee/searchEmployee',
        data: { search_type, username: this.leftSearchAll },
        loading: true,
      })
      .then((data: Array<object>) => {
        const response: Array<object> = [];
        for (const employee of data) {
          const item = {};
          item['title'] = employee['inverviewer_name'] ? employee['inverviewer_name'] : employee['username'];
          item['key'] = employee['inverviewer_uid'] ? employee['inverviewer_uid'] : employee['employee_id'];
          item['value'] = employee['inverviewer_uid'] ? employee['inverviewer_uid'] : employee['employee_id'];
          item['isLeaf'] = true;
          Object.assign(item, employee);
          response.push(item);
        }
        this.searchEmployeeData = [...response];
        this.showSearchData = [...response];
        this.showAllNoData = true;
        this.decisionCheckAll();
      });
  }

  /**
   * 右侧检索
   * @param $event
   */
  setRightSearch($event: any): void {
    this.rightSearch = $event;
  }

  /**
   * 清空所有选择
   */
  clear(): void {
    this.allRecommend = false;
    this.selectIds = [...[]];
    this.selectResult = [...[]];
  }

  /**
   * 输出结果
   */
  putResult(): void {
    this.sure.emit({ event: 'sure', target: this.selectResult });
  }

  close(): void {
    this.cancel.emit({ event: 'cancel' });
  }

  /**
   * 处理已选数据的回显
   * @private
   */
  private dealResultShow(): void {
    this.selectResult = [...this.checkData];
    const selectIds = [];
    this.checkData.map((item) => {
      selectIds.push(item['key']);
    });
    this.selectIds = [...selectIds];
  }

  test($event: MouseEvent): void {}

  /**
   * 选择员工
   * @param item
   */
  selectEmployee(item: object): void {
    let selectIds = [...this.selectIds];
    let selectResult = [...this.selectResult];
    const index = selectIds.indexOf(item['key']);
    if (index == -1) {
      // 判断选择模式是否是单选
      if (!this.nzMultiple) {
        selectIds.push(item['key']);
        selectResult.push(item);
      } else {
        selectIds = [item['key']];
        selectResult = [item];
      }
    } else {
      selectIds.splice(index, 1);
      this.selectResult.map((i, index) => {
        if (i['key'] == item['key']) {
          selectResult.splice(index, 1);
        }
      });
    }
    this.selectIds = [...selectIds];
    this.selectResult = [...selectResult];
  }

  /**
   * 删除检索信息
   */
  clearSearch(): void {
    this.leftSearchRecommend = '';
    this.leftSearchAll = '';
    this.showRecommendData = [...this.recommendData];
    this.showAllNoData = false;
    this.showSearchData = [...[]];
    this.searchRecommend();
    this.decisionCheckAll();
  }

  /**
   * 检索推荐数据
   * @param $event
   */
  searchRecommend(): void {
    // this.leftSearch = $event.target['value'];
    if (this.leftSearchRecommend == '') {
      // 如果检索关键字为空则将所有推荐数据都放入展示
      this.showRecommendData = [...this.recommendData];
    } else {
      const _showRecommendData = [];
      // 将符合条件的数据放入展示
      for (const i of this.recommendData) {
        if (i['title'].indexOf(this.leftSearchRecommend) > -1) {
          _showRecommendData.push(i);
        }
      }
      this.showRecommendData = [..._showRecommendData];
    }
    this.decisionCheckAll();
  }

  private decisionCheckAll(): void {
    // 判断推荐数据是否已经全选
    const _recommendCheckAll = this.showRecommendData.every((item) => {
      return this.selectIds.indexOf(item['key']) > -1;
    });
    this.recommendCheckAll = _recommendCheckAll;
    const _searchCheckAll = this.showSearchData.every((item) => {
      return this.selectIds.indexOf(item['key']) > -1;
    });
    this.searchCheckAll = _searchCheckAll;
  }

  /**
   * 全选检索出的数据
   * @param $event
   */
  checkAllSearch($event: any): void {
    const _selectIds = [...this.selectIds];
    const _selectResult = [...this.selectResult];
    if ($event) {
      // 全选
      /**
       * 遍历检索后的数据
       */
      for (const i of this.showSearchData) {
        if (_selectIds.indexOf(i['key']) == -1) {
          _selectIds.push(i['key']);
          _selectResult.push(i);
        }
      }
    } else {
      // 全不选
      // 清除所有的推荐数据
      this.showSearchData.map((item) => {
        if (_selectIds.indexOf(item['key']) > -1) {
          _selectIds.splice(_selectIds.indexOf(item['key']), 1);
          _selectResult.splice(_selectIds.indexOf(item['key']), 1);
        }
      });
    }
    this.selectIds = [..._selectIds];
    this.selectResult = [..._selectResult];
  }
}
